<template lang="pug">
.container.grid-lg.py-2
  loading-list(:loading="loading", :count="info.rows.length")
    div(v-if="info.usuario")
      .h4 {{ info.usuario.nome }}
      div(v-if="first && last")
        .columns
          .column
            small Registros de {{ first.realizado_em | date }} até {{ last.realizado_em | date }}
          .column.col-auto.tooltip.tooltip-left(
            data-tooltip="Registros por vêz"
          )
            select.form-select.select-sm(
              v-model="perPage",
              @change="fetchData(1)"
            )
              option(v-for="p in [10, 20, 30, 50, 100, 500]", :value="p") {{ p }}
        .mt-2
          small
            .columns.col-gapless
              .column.col-auto
                a.c-hand(@click="prevPage", :disabled="page === 1")
                  i.mr-1.fa.fa-chevron-left
                  | Mais recentes
              .column.col-auto.mx-2 ou
              .column.col-auto
                a.c-hand(@click="nextPage", :disabled="page === pages")
                  | Mais antigas
                  i.ml-1.fa.fa-chevron-right
    .divider
    v-map.mt-2.map-style(:center="center", :zoom="14")
      v-marker(
        v-for="geo in info.rows",
        :options="{ icon: '/img/pin_red.png' }",
        :key="geo.id",
        :position="{ lat: geo.latitude, lng: geo.longitude }",
        :info-window="infoWindow(geo)"
      )
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import usuarioGeos from "@/api/usuarioGeos"
import ApiInfoService from "@/lib/ApiInfoService"
export default {
  data() {
    return {
      loading: false,
      info: { rows: [] },
      perPage: 50,
    }
  },
  computed: {
    page() {
      return this.info.page || 1
    },
    pages() {
      return this.info.pages || 1
    },
    first() {
      if (!this.info.rows.length) return null
      return this.info.rows[0]
    },
    last() {
      if (!this.info.rows.length) return null
      return this.info.rows[this.info.rows.length - 1]
    },
    center() {
      if (this.first) {
        return { lat: this.first.latitude, lng: this.first.longitude }
      }

      return ApiInfoService.getInfo().municipio_local
    },
  },
  methods: {
    prevPage() {
      this.fetchData(this.page - 1)
    },
    nextPage() {
      this.fetchData(this.page + 1)
    },
    infoWindow(geo) {
      const date = this.$options.filters.date(geo.realizado_em)
      return `
        <div>
          Em: <b>${date}</b>
        </div>
      `
    },
    async fetchData(page = 1) {
      try {
        this.loading = true
        this.info = await usuarioGeos.show(this.$route.params.id, {
          page,
          perPage: this.perPage,
        })
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchData()
  },
}
</script>

<style lang="stylus" scoped>
.map-style {
  height: calc(100vh - 198px);
}
</style>
